const RELOAD_TIMESTAMP_KEY = "chunkReloadGuard:lastReloadAt";
const RELOAD_COOLDOWN_MS = 30_000;

function readLastReloadAt(): number | null {
  try {
    return Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY)) || 0;
  } catch {
    return null;
  }
}

function markReloadedNow(): boolean {
  try {
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}

function handlePreloadError(event: Event) {
  const lastReloadAt = readLastReloadAt();
  if (lastReloadAt === null) return;
  if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) return;
  if (!markReloadedNow()) return;
  event.preventDefault();
  window.location.reload();
}

export function registerChunkReloadGuard(): () => void {
  window.addEventListener("vite:preloadError", handlePreloadError);
  return function unregisterChunkReloadGuard() {
    window.removeEventListener("vite:preloadError", handlePreloadError);
  };
}
